import * as R from "ramda";

const root = R.lensProp("errors");

export default Object.assign(root, {});
